import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const Login = ({ setUser, setIsAuthenticated, darkMode, showNotification }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Store the token in local storage
        localStorage.setItem('token', data.token);

        // Decode the token to get user info
        const decodedToken = jwtDecode(data.token);
        const user = {
          name: decodedToken.name,
          roles: [decodedToken.role],
        };

        // Store user information in local storage
        localStorage.setItem('user', JSON.stringify(user));

        // Set the user and authentication state
        setIsAuthenticated(true);
        setUser(user);

        // Show success notification
        showNotification('Login successful', 'success');

        navigate('/users'); // Redirect to the user list page
      } else {
        showNotification(`Error: ${data.error}`, 'error');
      }
    } catch (error) {
      showNotification('Error logging in', 'error');
    }
  };

  return (
    <div className={`max-w-md mx-auto p-6 rounded shadow-md ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-black'}`}>
      <h2 className="text-2xl font-bold mb-4">Login</h2>
      <form onSubmit={handleSubmit}>
        <label className="block mb-2">
          Email or Username:
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`mt-1 p-2 w-full border rounded ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-black'}`}
            required
          />
        </label>
        <label className="block mb-4">
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`mt-1 p-2 w-full border rounded ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-black'}`}
            required
          />
        </label>
        <button type="submit" className="bg-blue-500 text-white p-2 rounded w-full">
          Login
        </button>
      </form>
      <div className="mt-4 text-center">
        <span>Don't have an account? </span>
        <Link to="/register" className="text-blue-500 underline">
          Register
        </Link>
      </div>
    </div>
  );
};

export default Login;
